export const ADD_ANTIHOMOTOXICOS = "ADD_ANTIHOMOTOXICOS";
